import { ChevronDown, ChevronRight, SquareArrowOutUpRight } from 'lucide-react';

import type { Post } from '@/entities/post/types';
import { Button } from '@/shared/components/shadcn/button';
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '@/shared/components/shadcn/popover';

type PostHeaderProps = {
  post: Post;
  onSaveToList: () => void;
  savedBoards?: { id: string; title: string }[];
  onOpenBoard: (boardId: string) => void;
};

export const PostHeader = ({
  post,
  onSaveToList,
  savedBoards,
  onOpenBoard,
}: PostHeaderProps) => {
  const openOriginalPost = () => {
    window.open(post.source.url, '_blank', 'noopener,noreferrer');
  };
  const savedBoardCount = savedBoards?.length || 0;

  return (
    <div className="flex items-start justify-between gap-4">
      <div>
        <h1 className="text-xl font-semibold">Post details</h1>
      </div>
      <div className="flex items-center gap-3">
        {savedBoardCount > 0 && (
          <Popover>
            <PopoverTrigger asChild>
              <button
                type="button"
                aria-haspopup="dialog"
                className="text-muted-foreground hover:text-foreground mr-1 inline-flex cursor-pointer items-center gap-1 text-sm font-medium"
              >
                <span>Saved in</span>
                <span className="text-foreground font-semibold">{savedBoardCount}</span>
                <span>board{savedBoardCount > 1 ? 's' : ''}</span>
                <ChevronDown className="text-muted-foreground size-3.5" />
              </button>
            </PopoverTrigger>
            <PopoverContent align="end" className="w-80 p-2">
              <div className="max-h-64 overflow-auto">
                {savedBoards?.map((board) => (
                  <button
                    key={board.id}
                    type="button"
                    className="hover:bg-accent flex w-full items-center justify-between rounded-md px-2 py-2 text-left"
                    onClick={() => onOpenBoard(board.id)}
                  >
                    <span className="truncate text-sm">{board.title}</span>
                    <ChevronRight className="text-muted-foreground size-4 shrink-0" />
                  </button>
                ))}
              </div>
            </PopoverContent>
          </Popover>
        )}
        <Button variant="outline" onClick={onSaveToList}>
          Save to boards
        </Button>
        <Button onClick={openOriginalPost}>
          <SquareArrowOutUpRight />
          Go to original
        </Button>
      </div>
    </div>
  );
};
